<template>
    <form role="form">
        <!--<loading :active.sync="isLoading"
                 :can-cancel="true"
                 :is-full-page="true">
        </loading>
        -->

        <div class="row d-flex justify-content-center">
            <div class="col-md-6">
                <div class="alert alert-danger" role="alert" v-if="(mode == 'approval' && form.approval_status > 0)">
                    <h4>{{ $t('requests.request-already-reviewed') }}</h4>
                    <button type="submit" class="btn btn-secondary"
                            @click.prevent="goBack">
                        {{ $t('buttons.back-abort') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <h5 class="col-md-4 text-md-right">{{ $t('orders.main-data') }}</h5>
        </div>

        <div class="form-group row" v-if="mode=='display' || mode=='edit'" key="orderNumberKey">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.order-number') }}</label>
            <div class="col-md-6">
                <input :disabled="true" type="text" class="form-control" name="desc" v-model="form.number">
            </div>
        </div>

        <div class="form-group row" v-if="(form.is_or_based_on_request == true && (mode=='display' || mode=='edit')) || mode == 'approval'" key="requestNumberKey">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.request-number') }}</label>
            <div class="col-md-6">
                <input disabled type="text" class="form-control" name="desc" v-model="form.request_number">
            </div>
        </div>

        <div class="form-group row" v-if="mode=='display' || mode == 'edit'" key="stateKey">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.current-state') }}</label>
            <div class="col-md-6">
                <input :disabled="true" type="state" class="form-control" name="desc" v-model="form.stateText">
            </div>
        </div>


        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.responsibility') }}</label>
            <div class="col-md-6">
                <kendo-dropdownlist ref="responsible_team_id_ref"
                                    style="width:300px"
                                    v-model="form.responsible_team_id"
                                    :text-field="'name'"
                                    :data-item-key="'id'"
                                    :value-field="'id'"
                                    :value-primitive="true"
                                    :data-items="teamsData"
                                    :default-item="placeholders.general_please_choose"
                                    :disabled="this.formdisabled"
                >
                </kendo-dropdownlist>
            </div>
        </div>


        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.internal-order') }}</label>
            <div class="col-md-6">
                <kendo-switch
                    :messages="switchInternalMessages"
                    :width="'70'"
                    v-model="form.internal_use"
                    :disabled="this.formdisabled"
                ></kendo-switch>
            </div>
        </div>

        <div class="form-group row" v-if="form.internal_use == true" key="internalUseSwitch">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.exhibition-order') }}</label>
            <div class="col-md-6">
                <kendo-switch
                    v-model="form.exhibition_use"
                    :messages="switchInternalMessages"
                    :width="'70'"
                    :disabled="formdisabled"
                ></kendo-switch>
            </div>
        </div>

        <div class="form-group row" v-if="form.internal_use == false" key="internalUseContact">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.internal-contact') }}</label>
            <div class="col-md-3">
                <customer-picker
                    @apply="onResponsibilityChange"
                    :presetcustomerid="form.responsibility_id"
                    :formdisabled="formdisabled"
                ></customer-picker>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.rent-recipient') }}</label>
            <div class="col-md-3">
                <customer-picker
                    @apply="onCustomerChange"
                    :presetcustomerid="form.customerId"
                    :formdisabled="formdisabled"
                ></customer-picker>
            </div>
        </div>

        <!-- Checkbox um den Mietempfänger über den Auftrag zu informieren -->
        <div class="form-group row" v-if="this.mode == 'create' || this.mode == 'create-duplicated'">
          <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.recipient_create_contact_send_mail') }}</label>
          <div class="col-md-6">
            <kendo-switch
                v-model="form.recipient_create_contact_send_mail"
                :messages="switchInternalMessages"
                :width="'70'"
                :checked="this.form.recipient_create_contact_send_mail"
                :disabled="this.formdisabled"
            ></kendo-switch>
          </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.purpose') }}</label>
            <div class="col-md-6">
                <input :disabled="this.formdisabled" type="text" class="form-control" name="desc" v-model="form.desc" :placeholder="$t('orders.purpose-placeholder')">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.order-location-country') }}</label>
            <div class="col-md-3">
                <input :disabled="this.formdisabled" type="text" class="form-control" name="order_location" v-model="form.order_location" :placeholder="$t('orders.order-location-placeholder')">
            </div>
            <div class="col-md-3">
                <input :disabled="this.formdisabled" type="text" class="form-control" name="order_country" v-model="form.order_country" :placeholder="$t('orders.order-country-placeholder')">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.tags') }}</label>
            <div class="col-md-6">
                <kendo-multiselect ref="tagbox"
                                   v-model="form.tags"
                                   :data-items="tagDatasource"
                                   :text-field="'text'"
                                   :allow-custom="true"
                                   :value-field="'value'"
                                   :data-item-key="'id'"
                                   :filterable="true"
                                   :placeholder="$t('general.please_choose_tags')"
                                   :disabled="this.formdisabled"
                                   @filterchange="onTagboxFilterChange"
                >
                </kendo-multiselect>
            </div>
        </div>

        <!-- DatePicker -->
        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.desired-period') }}</label>
            <div class="col-md-6" v-if="this.loadedOrder != false || (this.mode == 'create' || this.mode == 'create-duplicated')">
                <date-picker
                    id="datepicker"
                    @apply="onDateChange"
                    @loaded="onDatePickerLoaded"
                    :mode="'orders'"
                    :presetTimes="getPresetTimes"
                    :disabled="this.formdisabled"
                ></date-picker>
                <!-- Beim Anlegen oder Bearbeiten eine Warnung anzeigen, wenn der Zeitraum ganz oder teilweise in der Vergangenheit liegt -->
                <div class="alert alert-warning mt-2" role="alert" v-if="this.dateIsInPast && (this.mode == 'create' || this.mode == 'create-duplicated' || this.mode == 'edit')">
                    {{$t('orders.form.date-in-past')}}
                </div>
            </div>
        </div>


        <!-- Art der Herausgabe -->
        <div class="form-group row">
            <h5 class="col-md-4 text-md-right pt-2">{{ $t('orders.check-out') }}</h5>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.check-out-type') }}</label>
            <div class="col-md-6">
                <kendo-dropdownlist ref="pickupMethodDropdown"
                                    style="width:300px"
                                    v-model="form.delivery_method_id"
                                    :data-items="pickupMethodDatasource"
                                    :text-field="'name'"
                                    :value-field="'id'"
                                    :data-item-key="'id'"
                                    :value-primitive="true"
                                    :default-item="placeholders.general_please_choose"
                                    :disabled="formdisabled"
                >
                </kendo-dropdownlist>
            </div>
        </div>


        <!-- Herausgabeort -->
        <div v-if="this.form.delivery_method_id == 1" key="pickupPlaceKey">
            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.check-out-location') }}</label>
                <div class="col-md-6">
                    <kendo-dropdownlist
                        style="width:300px"
                        ref="tagboxPickupPlace"
                        v-model="form.delivery_location"
                        :data-items="tagPickupRetPlaceDatasource"
                        :text-field="'text'"
                        :value-field="'id'"
                        :data-item-key="'id'"
                        :value-primitive="true"
                        :default-item="placeholders.tagPickup"
                        :disabled="formdisabled"
                    >
                    </kendo-dropdownlist>
                </div>
            </div>
        </div>

        <div v-if="this.form.delivery_method_id==2 || this.form.delivery_method_id==3 || this.form.delivery_method_id==4" key="deliveryMethodAddress">
            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.shipping-to') }}</label>
                <div class="col-md-6">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="self" v-model="form.delivery_target_type" :disabled="this.formdisabled">
                        <label class="form-check-label" for="inlineRadio1">{{ $t('orders.ship-to-address-of-recipient') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="other" v-model="form.delivery_target_type" :disabled="this.formdisabled">
                        <label class="form-check-label" for="inlineRadio2">{{ $t('orders.ship-to-different-address') }}</label>
                    </div>
                </div>
            </div>

            <!-- Adresse des Mietempfängers -->
            <div v-if="form.delivery_target_type == 'self' && this.customerData != 0" key="deliveryTargetTypeShowAddress">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-2">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">{{ customerData['first_name'] }} {{ customerData['last_name'] }}</h5>
                                <div class="card-text">
                                    {{ customerData['company'] }}<br>
                                    {{ customerData['address'] }}<br>
                                    {{ customerData['city'] }} {{ customerData['zip'] }}<br>
                                    {{ customerData['country'] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Abweichende Adresse -->
            <div v-if="form.delivery_target_type == 'other'" key="deliveryTargetTypeOther">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-2">
                        <label for="delivery_target_type_other_name">{{ $t('address.first-name') }}</label>
                        <input type="text" class="form-control" id="delivery_target_type_other_name" placeholder="" v-model="form.delivery_target_type_other['name']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="delivery_target_type_other_surname">{{ $t('address.name') }}</label>
                        <input type="text" class="form-control" id="delivery_target_type_other_surname" placeholder="" v-model="form.delivery_target_type_other['surname']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="delivery_target_type_other_company">{{ $t('address.company') }}</label>
                        <input type="text" class="form-control" id="delivery_target_type_other_company" placeholder="" v-model="form.delivery_target_type_other['company']" :disabled="this.formdisabled">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-4">
                        <label for="delivery_target_type_other_street">{{ $t('address.street') }}</label>
                        <input type="text" class="form-control" id="delivery_target_type_other_street" :placeholder=" $t('address.street')" v-model="form.delivery_target_type_other['address']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="delivery_target_type_other_additional">{{ $t('address.note') }}</label>
                        <input type="text" class="form-control" id="delivery_target_type_other_additional" :placeholder="$t('address.note-placeholder')" v-model="form.delivery_target_type_other['additional']" :disabled="this.formdisabled">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-1">
                        <label for="delivery_target_type_other_zip">{{ $t('address.zip') }}</label>
                        <input type="text" class="form-control" id="delivery_target_type_other_zip" v-model="form.delivery_target_type_other['zip']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-3">
                        <label for="delivery_target_type_other_city">{{ $t('address.city') }}</label>
                        <input type="text" class="form-control" id="delivery_target_type_other_city" v-model="form.delivery_target_type_other['city']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="delivery_target_type_other_country">{{ $t('address.country') }}</label>
                        <input type="text" class="form-control" id="delivery_target_type_other_country" v-model="form.delivery_target_type_other['country']" :disabled="this.formdisabled">
                    </div>
                </div>
            </div>
        </div>

        <!-- Checkbox um den Verantwortlichen für Herausgabe zu informieren -->
        <div class="form-group row" v-if="this.mode == 'create' || this.mode == 'create-duplicated'">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.check-out-mail') }}</label>
            <div class="col-md-6">
                <kendo-switch
                    v-model="this.form.delivery_contact_send_mail"
                    :messages="switchInternalMessages"
                    :width="'70'"
                    :disabled="this.formdisabled"
                ></kendo-switch>
            </div>
        </div>

        <div class="form-group row">
            <h5 class="col-md-4 text-md-right pt-2">{{ $t('orders.check-in') }}</h5>
        </div>


        <!-- Art der Rückgabe -->
        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.check-in-type') }}</label>
            <div class="col-md-6">
                <kendo-dropdownlist ref="deliveryMethodDropdown"
                                    style="width:300px"
                                    v-model="form.return_method_id"
                                    :data-items="returnMethodDatasource"
                                    :text-field="'name'"
                                    :value-field="'id'"
                                    :data-item-key="'id'"
                                    :value-primitive="true"
                                    :default-item="placeholders.general_please_choose"
                                    :disabled="this.formdisabled"
                 >
                </kendo-dropdownlist>
            </div>
        </div>

        <!-- Rückgabeort -->
        <div v-if="this.form.return_method_id == 1" key="returnPlaceKey">
            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.check-in-location') }}</label>
                <div class="col-md-6">
                    <kendo-dropdownlist
                        style="width:300px"
                        ref="tagboxRetPlace"
                        v-model="form.ret_location"
                        :data-items="tagPickupRetPlaceDatasource"
                        :text-field="'text'"
                        :value-field="'id'"
                        :data-item-key="'id'"
                        :value-primitive="true"
                        :default-item="placeholders.tagReturn"
                        :disabled="formdisabled"
                    >
                    </kendo-dropdownlist>
                </div>
            </div>
        </div>

        <!-- Rücksendung durch Mietempfänger -->
        <div v-if="this.form.return_method_id==2" key="returnByReceiverTypes">

            <!-- Rücksendung an: Zurück zum Absender / Abweichende Addresse -->
            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.return-to') }}</label>
                <div class="col-md-6">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="returnTargetTypeOptions" id="returnTargetTypeOptionReturnToSender" value="returnToSender" v-model="form.return_by_receiver_target_type" :disabled="this.formdisabled">
                        <label class="form-check-label" for="returnTargetTypeOptionSelf">{{ $t('orders.return-to-sender') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="returnTargetTypeOptions" id="returnTargetTypeOptionReturnToSenderOther" value="other" v-model="form.return_by_receiver_target_type" :disabled="this.formdisabled">
                        <label class="form-check-label" for="returnTargetTypeOptionOther">{{ $t('orders.return-to-different-address') }}</label>
                    </div>
                </div>
            </div>

            <!-- Rücksendung durch Mietempfänger : Abweichende Addresse-->
            <div v-if="form.return_by_receiver_target_type == 'other'" key="returnByReceiverTargetTypeOther">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-2">
                        <label for="return_by_receiver_target_type_other_name">{{ $t('address.first-name') }}</label>
                        <input type="text" class="form-control" id="return_by_receiver_target_type_other_name" placeholder="" v-model="form.return_by_receiver_target_type_other['name']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="return_by_receiver_target_type_other_surname">{{ $t('address.name') }}</label>
                        <input type="text" class="form-control" id="return_by_receiver_target_type_other_surname" placeholder="" v-model="form.return_by_receiver_target_type_other['surname']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="return_by_receiver_target_type_other_company">{{ $t('address.company') }}</label>
                        <input type="text" class="form-control" id="return_by_receiver_target_type_other_company" placeholder="" v-model="form.return_by_receiver_target_type_other['company']" :disabled="this.formdisabled">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-4">
                        <label for="return_by_receiver_target_type_other_street">{{ $t('address.street') }}</label>
                        <input type="text" class="form-control" id="return_by_receiver_target_type_other_street" :placeholder="$t('address.street')" v-model="form.return_by_receiver_target_type_other['address']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="return_by_receiver_target_type_other_additional">{{ $t('address.note') }}</label>
                        <input type="text" class="form-control" id="return_by_receiver_target_type_other_additional" :placeholder="$t('address.note-placeholder')" v-model="form.return_by_receiver_target_type_other['additional']" :disabled="this.formdisabled">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-1">
                        <label for="return_by_receiver_target_type_other_zip">{{ $t('address.zip') }}</label>
                        <input type="text" class="form-control" id="return_by_receiver_target_type_other_zip" v-model="form.return_by_receiver_target_type_other['zip']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-3">
                        <label for="return_by_receiver_target_type_other_city">{{ $t('address.city') }}</label>
                        <input type="text" class="form-control" id="return_by_receiver_target_type_other_city" v-model="form.return_by_receiver_target_type_other['city']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="return_by_receiver_target_type_other_country">{{ $t('address.country') }}</label>
                        <input type="text" class="form-control" id="return_by_receiver_target_type_other_country" v-model="form.return_by_receiver_target_type_other['country']" :disabled="this.formdisabled">
                    </div>
                </div>
            </div>

        </div>

        <!-- Abholung / Rücksendung durch Bosch eBike oder Evolan-->
        <div v-if="this.form.return_method_id==3 || this.form.return_method_id==4 || this.form.return_method_id==5 || this.form.return_method_id==6 ||this.form.return_method_id==7" key="returnMethodAddress">

            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.pickup-return-from') }}</label>
                <div class="col-md-6">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="returnTargetTypeOptions" id="returnTargetTypeOptionSelf" value="self" v-model="form.return_target_type" :disabled="this.formdisabled">
                        <label class="form-check-label" for="returnTargetTypeOptionSelf">{{ $t('orders.pickup-return-from-address-of-recipient') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="returnTargetTypeOptions" id="returnTargetTypeOptionOther" value="other" v-model="form.return_target_type" :disabled="this.formdisabled">
                        <label class="form-check-label" for="returnTargetTypeOptionOther">{{ $t('orders.pickup-return-from-different-address') }}</label>
                    </div>
                </div>
            </div>

            <!-- Adresse des Mietempfängers -->
            <div v-if="form.return_target_type == 'self' && this.customerData != 0" key="deliveryTargetTypeShowAddress">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-2">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">{{ customerData['first_name'] }} {{ customerData['last_name'] }}</h5>
                                <div class="card-text">
                                    {{ customerData['company'] }}<br>
                                    {{ customerData['address'] }}<br>
                                    {{ customerData['city'] }} {{ customerData['zip'] }}<br>
                                    {{ customerData['country'] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="form.return_target_type == 'other'" key="returnTargetTypeOther">
                <!-- Datenübernahme von "anderer Adresse" der Lieferung -->
                <div class="form-group row" v-if="form.delivery_target_type == 'other' && !formdisabled" key="returnTargetTypeOtherApplyFromDelivery">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>

                    <div class="col-md-2">
                        <a class="k-button form-control" @click="applyOtherReturnAddressFromOtherDeliveryAddress"><span class="k-icon k-i-copy"></span>&nbsp; {{ $t('orders.use-address-from-shipping') }}</a>
                    </div>
                    <div class="col-md-1">
                        <a class="k-button form-control" @click="resetOtherReturnAddress"><span class="k-icon k-i-reset"></span>&nbsp; {{ $t('general.clear_fields') }}</a>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-2">
                        <label for="return_target_type_other_name">{{ $t('address.first-name') }}</label>
                        <input type="text" class="form-control" id="return_target_type_other_name" placeholder="" v-model="form.return_target_type_other['name']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="return_target_type_other_surname">{{ $t('address.name') }}</label>
                        <input type="text" class="form-control" id="return_target_type_other_surname" placeholder="" v-model="form.return_target_type_other['surname']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="return_target_type_other_company">{{ $t('address.company') }}</label>
                        <input type="text" class="form-control" id="return_target_type_other_company" placeholder="" v-model="form.return_target_type_other['company']" :disabled="this.formdisabled">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-4">
                        <label for="return_target_type_other_street">{{ $t('address.street') }}</label>
                        <input type="text" class="form-control" id="return_target_type_other_street" :placeholder="$t('address.street-placeholder')" v-model="form.return_target_type_other['address']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="return_target_type_other_additional">{{ $t('address.note') }}</label>
                        <input type="text" class="form-control" id="return_target_type_other_additional" :placeholder="$t('address.note-placeholder')" v-model="form.return_target_type_other['additional']" :disabled="this.formdisabled">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                    <div class="col-md-1">
                        <label for="return_target_type_other_zip">{{ $t('address.zip') }}</label>
                        <input type="text" class="form-control" id="return_target_type_other_zip" v-model="form.return_target_type_other['zip']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-3">
                        <label for="return_target_type_other_city">{{ $t('address.city') }}</label>
                        <input type="text" class="form-control" id="return_target_type_other_city" v-model="form.return_target_type_other['city']" :disabled="this.formdisabled">
                    </div>
                    <div class="col-md-2">
                        <label for="return_target_type_other_country">{{ $t('address.country') }}</label>
                        <input type="text" class="form-control" id="return_target_type_other_country" v-model="form.return_target_type_other['country']" :disabled="this.formdisabled">
                    </div>
                </div>
            </div>



            <!--
            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">Abholadresse</label>
                <div class="col-md-6">
                    <textarea :disabled="this.formdisabled" type="text" class="form-control" name="pickupAddress" v-model="form.pickupAddress" placeholder="Abholadresse"></textarea>
                </div>
            </div>-->
        </div>

        <!-- Checkbox um den Verantwortlichen für Rückgabe zu informieren -->
        <div class="form-group row" v-if="this.mode == 'create' || this.mode == 'create-duplicated'">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.check-in-mail') }}</label>
            <div class="col-md-6">
                <kendo-switch
                    v-model="form.return_contact_send_mail"
                    :messages="switchInternalMessages"
                    :width="'70'"
                    :checked="this.form.return_contact_send_mail"
                    :disabled="this.formdisabled"
                ></kendo-switch>
            </div>
        </div>


        <div v-if="mode=='approval'">

            <hr>
            <div class="form-group row">
                <h4 class="col-md-4 text-md-right pt-2">{{ $t('requestpage.request-type') }}</h4>
            </div>


            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right"></label>
                <div class="col-md-6">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioRequestType" id="inlineRadioSpecific" value="specific" v-model="form.request_equipment_select_type">
                        <label class="form-check-label" for="inlineRadioSpecific">{{ $t('requestpage.equipment-direct') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioRequestType" id="inlineRadioFree" value="unspecific" v-model="form.request_equipment_select_type">
                        <label class="form-check-label" for="inlineRadioFree">{{ $t('requestpage.equipment-choose') }}</label>
                    </div>
                </div>
            </div>


            <div class="form-group row" v-show="form.request_equipment_select_type =='unspecific'">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.equipment-description') }}</label>

                <div class="col-md-6" v-show="form.request_equipment_select_type =='unspecific'">
                    <textarea :disabled="equipmentDescLocked" type="text" rows=6 class="form-control" name="noteField" v-model="form.request_desc" :placeholder="$t('requestpage.equipment-description-placeholder')"></textarea>
                </div>
            </div>


            <div class="form-group row">
                <h5 class="col-md-4 text-md-right pt-2"></h5>
            </div>
            <div class="form-group row" style="padding-bottom:25px;">
                <label class="col-md-4 col-form-label text-md-right"></label>
                <div class="col-md-7">
                    <object-picker-br
                        ref="objectpicker"
                        @objectAdd="onObjectAdd"
                        @objectRemove="onObjectRemove"
                        :availabilityDates="form.dates"
                        :mode="mode"
                        :formdisabled="formdisabled"
                        :orderid="this.orderid"
                        :pickType="'requestApproval'"
                        :presetobjects="form.rmsObjects"
                        :presetobjectid="presetobjectid"
                    >
                    </object-picker-br>
                </div>
            </div>

            <div class="form-group row">
                <h4 class="col-md-4 text-md-right pt-2">{{ $t('requestpage.additional-info') }}</h4>
            </div>

            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.additional-label') }}</label>

                <div class="col-md-6">
                    <textarea :disabled="formdisabled" type="text" class="form-control" name="noteField" v-model="form.request_note" :placeholder="$t('requestpage.additional-placeholder')"></textarea>
                </div>
            </div>

        </div>

        <div v-if="mode != 'approval'">
            <div class="form-group row">
                <h5 class="col-md-4 text-md-right pt-2">{{ $t('requestpage.equipment') }}</h5>
            </div>

            <!-- Beschreibung der Leihgegenstände immer zeigen, falls gesetzt -->
            <div class="form-group row" v-if="form.request_desc">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.equipment-description') }}</label>

                <div class="col-md-6">
                    <textarea :disabled="equipmentDescLocked" type="text" rows=6 class="form-control" name="noteField" v-model="form.request_desc" :placeholder="$t('requestpage.equipment-description-placeholder')"></textarea>
                </div>
            </div>

            <div class="form-group row" style="padding-bottom:25px;">
                <label class="col-md-4 col-form-label text-md-right"></label>
                <div class="col-md-7">
                    <object-picker-br
                        ref="objectpicker"
                        @objectAdd="onObjectAdd"
                        @objectRemove="onObjectRemove"
                        :availabilityDates="form.dates"
                        :mode="mode"
                        :orderid="this.orderid"
                        :pickType="'order'"
                        :formdisabled="formdisabled"
                        :presetobjects="form.rmsObjects"
                        :presetobjectid="presetobjectid"
                    >
                    </object-picker-br>
                </div>
            </div>

            <div class="form-group row">
                <h4 class="col-md-4 text-md-right pt-2">{{ $t('requestpage.additional-info') }} </h4>
            </div>

            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.additional-label') }}</label>

                <div class="col-md-6">
                    <textarea :disabled="this.formdisabled" type="text" class="form-control" name="noteField" v-model="form.request_note" :placeholder="$t('requestpage.additional-placeholder')"></textarea>
                </div>
            </div>
        </div>

        <div class="form-group row mb-0">
            <div class="col-md-6 offset-md-4">
                <!--<button type="submit" class="btn btn-primary" v-if="mode == 'create'"
                        @click.prevent="createDraft">
                    Als Entwurf speichern
                </button>-->

                <button type="submit" class="btn btn-secondary" v-if="mode != 'display'"
                        @click.prevent="goBack">
                    {{ $t('buttons.back-abort') }}
                </button>
                <button type="submit" class="btn btn-secondary" v-if="mode == 'display'"
                        @click.prevent="goBack">
                    {{ $t('buttons.back-abort') }}
                </button>
                <button type="submit" class="btn btn-primary" v-if="mode == 'display'"
                        @click.prevent="editAction">
                    {{ $t('buttons.edit') }}
                </button>
                <button type="submit" class="btn btn-success" v-if="mode == 'checkout'"
                        @click.prevent="confirmCheckOut">
                    {{ $t('buttons.confirm-issuance') }}
                </button>
                <button type="submit" class="btn btn-success" v-if="mode == 'checkin'"
                        @click.prevent="confirmCheckIn">
                    {{ $t('buttons.confirm-return') }}
                </button>
                <button type="submit" class="btn btn-success" v-if="mode == 'approval' && form.approval_status == 0"
                        @click.prevent="approveRequest">
                    {{ $t('buttons.confirm') }}
                </button>
                <button type="submit" class="btn btn-warning" v-if="mode == 'approval' && form.approval_status == 0"
                        @click.prevent="rejectRequest">
                    {{ $t('buttons.reject') }}
                </button>
                <button type="submit" class="btn btn-success" v-if="mode == 'create' || mode == 'create-duplicated'"
                        @click.prevent="createOrder">
                    {{ $t('buttons.create') }}
                </button>
                <button type="submit" class="btn btn-success" v-if="mode == 'edit'"
                        @click.prevent="editOrder">
                    {{ $t('buttons.save') }}
                </button>

            </div>
        </div>
    </form>
</template>

<script>
    import CustomerPicker from "./customer-picker";
    import tagNoDataTemplate from "../rmsobjects/tag-nodata-template";
    import ObjectPickerBr from "./object-picker-br";
    import {filterBy} from "@progress/kendo-data-query";
    import swal from "sweetalert2";
    import {$t} from "../../i18Instance";

    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/de.json"));
    export default {
        name: "form-order",
        components: {
            CustomerPicker,
            ObjectPickerBr,
        },
        props: {
            user: [String, Number],
            presetobjectid: [Number, Boolean],
            presetcustomerid: [Number, Boolean],
            orderid: [Number, Boolean],
            presetdata:[Object, Boolean],
            formdisabled: Boolean,
            mode: {
                type: String,
                default: 'create'
            },
            context:[String]
        },
        data: function () {
            return {
                teamsData:[],
                tagDatasource: [],
                tagDatasourceUnfiltered: [],
                tagPickupRetPlaceDatasource: [],
                pickupMethodDatasource: [],
                returnMethodDatasource: [],

                loadedOrder: false,
                dateIsInPast: false,
                isSubmitting: false,

                switchInternalMessages: {
                    checked: this.$t('general.bool_true'),
                    unchecked: this.$t('general.bool_false')
                },

                placeholders: {
                    general_please_choose: {
                        name: this.$t('general.please_choose')
                    },
                    tagPickup: {
                        text: this.$t('orders.check-out-location-placeholder')
                    },
                    tagReturn: {
                        text: this.$t('orders.check-in-location-placeholder')
                    }

                },

                loadedData: {},
                customerData: 0,
                responsibilityData: 0,
                today: '',
                form:{
                    responsible_team_id: null,
                    recipient_create_contact_send_mail: true,
                    number: '',
                    request_number:null,
                    desc: '',
                    tags:[],
                    request_desc:'',
                    request_equipment_select_type: 'specific',
                    order_location: '',
                    order_country: '',
                    delivery_method_id: null,
                    return_method_id: null,
                    request_note: '',
                    is_or_based_on_request: false,
                    internal_use: false,
                    exhibition_use: false,
                    delivery_location: null,
                    delivery_target_type: 'self',
                    delivery_target_type_other: {},
                    delivery_contact_send_mail: true,
                    ret_location: null,
                    return_target_type: 'self',
                    return_target_type_other: {},
                    return_by_receiver_target_type: 'returnToSender',
                    return_by_receiver_target_type_other: {},
                    return_contact_send_mail: true,
                    from: new Date(),
                    until: new Date(),
                    dates:{
                        from: new Date(),
                        until: new Date()
                    },
                    rmsObjects: new Array(),
                    customerId: this.presetcustomerid
                }
            }
        },
        computed:{
            equipmentDescLocked: function() {
                // Equipment-Beschreibung ist nur editierbar, solange der Antrag noch
                // ein Antrag ist (state < 30). Nach der Freigabe (= Auftrag) view-only.
                return this.formdisabled || (this.loadedOrder !== false && this.loadedOrder.state >= 30);
            },
            getPresetTimes: function(){
                console.log("form-order: getPresetTimes", {from: this.form.from, until: this.form.until});
                if(this.presetdata != undefined && this.presetdata !== false && this.presetdata.hasOwnProperty("startDate") && this.presetdata.hasOwnProperty("endDate")){
                    return {
                        from: moment(this.presetdata.startDate),
                        until: moment(this.presetdata.endDate),
                    };
                }else{
                    return {from: this.form.from, until: this.form.until};
                }
            },

        },
        mounted () {
            this.init();
        },
        methods: {
            // Übersetzt deutsche Texte im Namen der Datasource anhand cstrings-Tabelle
            translateDatasource: function(data){
                for (const dataKey in data) {
                    data[dataKey]['name'] = this.$t("cstrings." + data[dataKey]['name']);
                }
                return data;
            },
            translateReturnMethodDatasource: function(data){
                this.loadedData.availableReturnMethods = data;
                return this.translateDatasource(data);
            },
            translatePickupMethodDatasource: function(data){
                this.loadedData.availablePickupMethods = data;
                return this.translateDatasource(data);
            },

            init: function(){
                console.log("form-order init... ", this.orderid, this.mode, this.context);

                // Laden der Teams
                axios
                    .get('/api/orders/teams')
                    .then(response => {
                        this.teamsData = response.data
                    });

                // Laden der Tags
                axios
                    .get('/api/orders/tags')
                    .then(response => {
                        this.tagDatasource = response.data;
                        this.tagDatasourceUnfiltered = response.data;
                    });

                // Laden der Abhol und Rückgabe-Tags
                axios
                    .get('/api/orders/tagsPickupReturnPlace')
                    .then(response => {
                        this.tagPickupRetPlaceDatasource = response.data
                        console.log("available pickupReturnTags", response.data);
                    });

                // Laden der Liefermethoden
                axios
                    .get('/api/orders/deliveryMethods')
                    .then(response => {
                        this.pickupMethodDatasource = this.translateDatasource(response.data)
                        console.log("trans2",this.pickupMethodDatasource);
                    });


                // Laden der Rückgabemethoden
                axios
                    .get('/api/orders/returnMethods')
                    .then(response => {
                        this.returnMethodDatasource = this.translateDatasource(response.data)
                        console.log("trans1",this.returnMethodDatasource);
                    });



                // Laden eines bestehenden Auftrags
                if(this.orderid){
                    axios
                        .get('/api/orders/id/' + this.orderid)
                        .then(response => {
                            console.log("existing order / request loaded")
                            this.loadedOrder = response.data[0];
                            console.log(this.loadedOrder);
                            this.prepareEditData();
                        })
                        .catch(error => {
                            console.log("err", error);
                        })
                }
            },

            prepareData(){

                this.form.from = this.form.dates.from.format();
                this.form.until = this.form.dates.until.format();

                // Value vom Editor auslesen
                //let editor = this.$refs.noteField.kendoWidget();
                //this.form.requestNote = editor.value();

                //this.form.note = this.$refs['noteField'].getHTML();
            },

            /**
             * Bereitet die geladenen Daten für die Edit-Maske vor
             */
            prepareEditData: function() {
                console.log("loaded ORder vor setzen", this.loadedOrder);
                // Formulardaten setzen

                //this.form = this.loadedOrder;

                this.form.id = this.loadedOrder.id;
                this.form.number = this.loadedOrder.number;
                this.form.request_number = this.loadedOrder.request_number;
                this.form.is_or_based_on_request = this.loadedOrder.is_or_based_on_request;
                this.form.stateText = this.loadedOrder.stateText;
                this.form.responsible_team_id = this.loadedOrder.responsible_team_id;
                this.form.internal_use = this.loadedOrder.internal_use;
                this.form.exhibition_use = this.loadedOrder.exhibition_use;
                this.form.responsibility_id = this.loadedOrder.responsibility_id;

                if(this.loadedOrder.customer != null) this.form.customerId = this.loadedOrder.customer.id;

                this.form.desc = this.loadedOrder.desc;
                this.form.order_location = this.loadedOrder.order_location;
                this.form.order_country = this.loadedOrder.order_country;
                this.form.tags = this.loadedOrder.attachedTags;

                this.form.from = moment(this.loadedOrder.from);
                this.form.until = moment(this.loadedOrder.until);
                this.form.dates.from = moment(this.loadedOrder.from);
                this.form.dates.until = moment(this.loadedOrder.until);

                // Herausgabe
                this.form.delivery_location = this.loadedOrder.delivery_location;
                this.form.delivery_method_id = this.loadedOrder.delivery_method_id;
                this.form.delivery_target_type = this.loadedOrder.delivery_target_type;
                this.form.delivery_target_type_other = JSON.parse(this.loadedOrder.delivery_target_type_other);


                // Rücknahme
                this.form.ret_location = this.loadedOrder.return_location;
                this.form.return_method_id = this.loadedOrder.return_method_id;
                this.form.return_target_type = this.loadedOrder.return_target_type;
                this.form.return_by_receiver_target_type = this.loadedOrder.return_by_receiver_target_type;
                this.form.return_target_type_other = JSON.parse(this.loadedOrder.return_target_type_other);
                this.form.return_by_receiver_target_type_other = JSON.parse(this.loadedOrder.return_by_receiver_target_type_other); // Was ist das?

                // Antrag
                this.form.approval_status = this.loadedOrder.approval_status;

                this.form.rmsObjects = this.loadedOrder.rmsobjects;

                this.form.request_equipment_select_type = this.loadedOrder.request_equipment_select_type;
                this.form.request_desc = this.loadedOrder.request_desc;
                this.form.request_note = this.loadedOrder.request_note;

                console.log("currForm", this.form);
            },

            loadCustomerData: function(customerId){
                axios
                    .get('/api/customers/id/' + customerId)
                    .then(response => {
                        this.customerData = response.data;
                    })
                    .catch(error => {
                        console.log("err", error);
                    })
                    .finally(() => {
                    })
            },

            loadResponsibilityData: function(responsibilityId){
                axios
                    .get('/api/customers/id/' + responsibilityId)
                    .then(response => {
                        this.responsibilityData = response.data;
                    })
                    .catch(error => {
                        console.log("err", error);
                    })
                    .finally(() => {
                    })
            },

            onDatePickerLoaded: function (dates) {
                console.log("Picker loaded with dates", dates);
                this.form.dates = dates;
                this.form.from = dates.from;
                this.form.until = dates.until;
                // Store neu laden (auch falls equipment nur textlich beschrieben wird)
                this.$refs.objectpicker.reloadStore();
            },

            onDateChange: function (dates) {
                console.log("Buchungszeitraum geändert", dates);
                this.form.dates = dates;
                this.form.from = dates.from;
                this.form.until = dates.until;

                // Prüfen ob der gewählte Zeitraum ganz oder teilweise in der Vergangenheit ist
                if(this.form.from < moment().startOf('day') || this.form.until < moment().startOf('day') ){
                    this.dateIsInPast = true;
                }else {
                    this.dateIsInPast = false;
                }

                console.log("lade Verfügbarkeit der Verleihobjekte neu");
                // Store neu laden (auch falls equipment nur textlich beschrieben wird)
                this.$refs.objectpicker.reloadStore();
            },

            onCustomerChange: function (customerId) {
                console.log("Customer geändert", customerId);
                this.form.customerId = customerId;

                // alle Daten laden - Für Darstellung der Adresse des Mietempfängers
                let customerData = this.loadCustomerData(this.form.customerId);
            },

            onResponsibilityChange: function (responsibilityId) {
                this.form.responsibility_id = responsibilityId;
            },

            onObjectAdd: function(addedObject) {
                this.form.rmsObjects.push(addedObject);
            },

            onObjectRemove: function(removedObject) {
                this.form.rmsObjects = this.form.rmsObjects.filter(function( obj ) {
                    return obj.id !== removedObject.id;
                });
            },


            applyOtherReturnAddressFromOtherDeliveryAddress: function(){
              // Kann nicht einfach zugewiesen werden, da sonst gleiche Referenz und Reactivity
              this.form.return_target_type_other = JSON.parse(JSON.stringify(this.form.delivery_target_type_other));
            },

            resetOtherReturnAddress: function(){
                this.form.return_target_type_other = {};
            },

            /**
             * Öffnet dieses Fenster
             */
            showWindow(){
                this.today = new Date();
                var window = this.$refs.createWindow.kendoWidget();
                window.center().open();
            },

            /**
             * Schließt dieses Fenster
             */
            hideWindow(){
                var window = this.$refs.createWindow.kendoWidget();
                window.close();
            },

            resetForm(){
                this.form = {};
            },

            onWindowActivated(){
                this.$refs.firstInput.focus();
            },

            onWindowClosed(){
                this.resetForm();
            },

            /**
             * Sendet die Formulardaten zum Server und versucht den Auftrag anzulegen
             */
            createOrder() {
                this.prepareData();
                console.log(this.form);
                // Daten senden
                this.sendForm('post','/api/orders', this.form)
                    .then(() => {
                        //this.$emit('order-created');
                        this.onOrderCreated();
                    });
            },

            editOrder(){
                this.prepareData();
                // Daten senden
                this.sendForm('put','/api/orders/update/'+this.form.id, this.form)
                    .then(() => {
                        this.onOrderUpdated();
                        //this.$emit('order-updated');
                    },()=>{
                        this.onOrderUpdateFailed();
                        //this.$emit('order-update-failed');
                    });
            },

            editAction: function () {
                console.log("edit action", this.orderid);
                this.$router.push({ name: 'order-edit', params: {
                            orderid: this.orderid,
                            mode: 'edit',
                            context: this.context
                        }});
            },

            confirmCheckIn(){
                console.log("confirmCheckIn");
                this.sendForm('post', '/api/orders/checkin/'+this.form.id, this.form)
                    .then(() => {
                        this.OnOrderCheckedIn();
                    });
            },

            confirmCheckOut(){
                console.log("confirmCheckout");
                this.sendForm('post', '/api/orders/checkout/'+this.form.id, this.form)
                    .then(() => {
                        this.OnOrderCheckedOut();
                    });
            },

            approveRequest(){
                this.prepareData();
                swal.fire({
                    title: $t("requests.onAcceptAction.title"),
                    text: $t("requests.onAcceptAction.text"),
                    input: 'textarea',
                    inputPlaceholder: $t("requests.onAcceptAction.inputPlaceholder"),
                    inputAttributes: {
                        'aria-label': $t("requests.onAcceptAction.inputPlaceholder")
                    },
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: $t("general.cancel"),
                    confirmButtonText: $t("general.ok")
                }).then((isConfirmed) => {
                    if ("value" in isConfirmed) {
                        this.form.approved = true;
                        this.form.rejected = false;
                        this.form.approval_note = isConfirmed.value;
                        console.log("form:",this.form);
                        // Daten senden
                        this.sendForm('put','/api/request/update/'+this.form.id, this.form)
                            .then(() => {
                                this.$emit('request-approved');
                                //this.onRequestApproved();
                            });
                    } else {
                        return;
                    }
                });
            },

            rejectRequest(){
                this.prepareData();
                swal.fire({
                    title: $t("requests.onRejectAction.title"),
                    text: $t("requests.onRejectAction.text"),
                    input: 'textarea',
                    inputPlaceholder: $t("requests.onRejectAction.inputPlaceholder"),
                    inputAttributes: {
                        'aria-label': $t("requests.onRejectAction.inputPlaceholder")
                    },
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: $t("general.cancel"),
                    confirmButtonText: $t("general.ok")
                }).then((isConfirmed) => {
                    if ("value" in isConfirmed) {
                        this.form.approved = false;
                        this.form.rejected = true;
                        this.form.approval_note = isConfirmed.value;
                        // Daten senden
                        this.sendForm('put','/api/request/update/'+this.form.id, this.form)
                            .then(() => {
                                this.$emit('request-rejected');
                                //this.onRequestRejected();
                            });
                    } else {
                        return;
                    }
                });
            },


            goBack(){
                if(this.context != ""){
                    this.handleBack(this.context, false, {reload: false, id: this.form.id});
                }else{
                    this.handleBack('orders-grid', false, {reload: false, id: this.form.id});
                }
            },

            sendForm(method, uri, form){
                console.log("in sendForm");
                if (this.isSubmitting) {
                    // Schutz gegen Doppel-Klick: laufender Submit blockiert weitere
                    return Promise.reject({ duplicate: true });
                }
                this.isSubmitting = true;
                return new Promise((resolve, reject) => {
                    axios[method](uri, form)
                        .then(response => {
                            console.log("response from sendform", response.data);
                            resolve(response.data);
                        })
                        .catch(errors => {
                            // Server-Fehler dem User sichtbar machen. Auftragsnummer-Kollision
                            // (UNIQUE-Verletzung auf rents.number) bekommt eine spezifische Meldung,
                            // damit der User weiß, dass Neuladen hilft.
                            const status = errors && errors.response ? errors.response.status : null;
                            const raw = errors && errors.response && errors.response.data
                                ? (typeof errors.response.data === 'string'
                                    ? errors.response.data
                                    : (errors.response.data.message || JSON.stringify(errors.response.data)))
                                : '';
                            const isDuplicateNumber = status === 500
                                && /duplicate|unique|1062|rents_number_unique/i.test(raw);

                            swal.fire({
                                icon: 'error',
                                title: $t('general.error_title'),
                                text: isDuplicateNumber
                                    ? $t('general.save_error_duplicate')
                                    : $t('general.save_error_generic')
                            });

                            reject(errors.response ? errors.response.data : errors);
                        })
                        .finally(() => {
                            this.isSubmitting = false;
                        });
                });
            },

            // region Tag-Box

            onTagboxFilterChange(e){
                this.tagDatasource = filterBy(this.tagDatasourceUnfiltered.slice(), e.filter);
            },

            /**
             * Fügt durch Enter-Tastendruck einen neuen Tag hinzu
             * @param e
             */
            onTagboxKeyPress(e) {
                console.log(e);
                if (e.key !== "Enter") {
                    return;
                }
                e.preventDefault();

                let widget = this.$refs['tagbox'].kendoWidget();
                let newValue = widget.input.val();
                if(newValue.length > 0){
                    widget.dataSource.add({
                        text: newValue,
                        value: newValue
                    });

                    // Workaround für Kendo Bug
                    setTimeout(function(){
                        widget.value(widget.value().concat([newValue]));
                    }, 1);
                }
            },

            /**
             * Lädt das Template tag-nodata-template für die anzeige der Tagbox, wenn kein Tag gefunden werden kann
             * @param e
             * @returns {{template: {data, methods, name}, templateArgs: *}}
             */
            tagNoDataTemplateLoader(e){
                e.text = 'footer';
                e.context = this;
                e.widget = this.$refs['tagbox'].kendoWidget();
                return {
                    template: tagNoDataTemplate,
                    templateArgs: e
                }
            },

            tagboxPickupPlaceNoDataTemplateLoader(e){
                e.text = 'footer';
                e.context = this;
                e.widget = this.$refs['tagboxPickupPlace'].kendoWidget();
                return {
                    template: tagNoDataTemplate,
                    templateArgs: e
                }
            },

            tagboxRetPlaceNoDataTemplateLoader(e){
                e.text = 'footer';
                e.context = this;
                e.widget = this.$refs['tagboxRetPlace'].kendoWidget();
                return {
                    template: tagNoDataTemplate,
                    templateArgs: e
                }
            },


            //endregion

            /**
             * Eventhandler wird aufgerufen, wenn ein Auftrag angelegt wurde
             */
            onOrderCreated:function(){
                swal.fire({
                    title: $t('orders.creationSuccess.title'),
                    text: $t('orders.creationSuccess.text'),
                    icon: "success",
                    timer: 1000
                }).then(() => {
                    if(this.context != ""){
                        this.handleBack(this.context, true, {reload: true, id: this.form.id});
                    }else{
                        this.handleBack('orders-grid', true, {reload: true, id: this.form.id});
                    }
                });
            },

            onOrderUpdated:function(){
                swal.fire({
                    title: $t('orders.updateSuccess.title'),
                    text: $t('orders.updateSuccess.text'),
                    icon: "success",
                    timer: 1000
                }).then(() => {
                    if(this.context != ""){
                        this.handleBack(this.context, true, {reload: true, id: this.form.id});
                    }else{
                        this.handleBack('orders-grid', true, {reload: true, id: this.form.id});
                    }

                    //window.location.href = '/orders';
                });
            },

            onOrderUpdateFailed:function(){
                swal.fire({
                    title: $t('orders.updateFailure.title'),
                    text: $t('orders.updateFailure.text'),
                    icon: "error",
                }).then(() => {
                    if(this.context != ""){
                        this.handleBack(this.context, true, {reload: true, id: this.form.id});
                    }else{
                        this.handleBack('orders-grid', true, {reload: true, id: this.form.id});
                    }
                });
            },

            OnOrderCheckedIn:function(){
                swal.fire({
                    title: $t('orders.bikesReturnSuccess.title'),
                    text: $t('orders.bikesReturnSuccess.text'),
                    icon: "success",
                    timer: 1000
                }).then(() => {
                    if(this.context != ""){
                        this.handleBack(this.context, true, {reload: true, id: this.form.id});
                    }else{
                        this.handleBack('orders-grid', true, {reload: true, id: this.form.id});
                    }
                });
            },


            OnOrderCheckedOut:function(){
                swal.fire({
                    title: $t('orders.bikesIssueSuccess.title'),
                    text: $t('orders.bikesIssueSuccess.text'),
                    icon: "success",
                    timer: 1000
                }).then(() => {
                    if(this.context != ""){
                        this.handleBack(this.context, true, {reload: true, id: this.form.id});
                    }else{
                        this.handleBack('orders-grid', true, {reload: true, id: this.form.id});
                    }
                });
            },


        }
    }
</script>

<style scoped>
    .objPicker{
        height:500px!important;
    }
    .descriptionPaddingTop{
        padding-top:40px;
    }
</style>
